import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';

import '@Root/lib/lit-3form-block/components/cta-button';

import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

import { styles } from './css';
export class DirectGroup extends Lit3formBlock {
  static get characterName() {
    return 'direct-group';
  }

  static get characterStyles() {
    return [...styles];
  }

  static properties = {
    _accountInfoExpanded: { type: Boolean },
    _projectManagerExpanded: { type: Boolean },
    _downloadsExpanded: { type: Boolean },
  };

  constructor() {
    super();
    this._accountInfoExpanded = false;
    this._projectManagerExpanded = false;
    this._downloadsExpanded = false;
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class=${classMap({
          'block-grid': true,
          'direct-group-layout': !this.featureImgUrl,
          'direct-group-layout-with-feature-img': !!this.featureImgUrl,
        })}>
          <div class="header">
            <span class="company-logo">
              <img src="${this.logoUrl}" />
              <h1 class="header-text">${this.headerText}</h1>
            </span>
            <a class="return-to-groups" href="/direct">
              <img src="/static/icons/SVG/arrow-black-1px-4x8.svg" />
              <p class="font-size-small">Return to Groups</p>
            </a>
          </div>
          ${
            this.featureImgUrl
              ? html`
                  <span class="feature-img-wrapper">
                    <img src=${this.featureImgUrl} />
                  </span>
                `
              : html``
          }
          <span
            class=${classMap({
              'section-wrapper': true,
              'account-information': true,
              'section-wrapper-expanded': this._accountInfoExpanded,
              'section-wrapper-closed': !this._accountInfoExpanded,
            })}
          >
            <div
              class="section-header"
              @click="${() => this.toggleSectionOpen('account-information')}"
            >
              <h3>ACCOUNT INFORMATION</h3>
              <img class="mobile-only" src=${this.sectionHeaderIcon(
                'account-information'
              )} />
            </div>
            <div
              class="section-details"
              id="account-information"
            >${this.accountInformationHTML}</div>
          </span>
          <span
            class=${classMap({
              'section-wrapper': true,
              'project-manager': true,
              'section-wrapper-expanded': this._projectManagerExpanded,
              'section-wrapper-closed': !this._projectManagerExpanded,
            })}
          >
            <div
              class="section-header"
              @click="${() => this.toggleSectionOpen('project-manager')}"
            >
              <h3>PROJECT MANAGER</h3>
              <img class="mobile-only" src=${this.sectionHeaderIcon(
                'project-manager'
              )} />
            </div>
            <div
              class="section-details"
              id="project-manager"
            >${this.projectManagerHTML}</div>
          </span>
          ${
            !!this.content.downloads.length
              ? html`
                  <span
                    class=${classMap({
                      'section-wrapper': true,
                      downloads: true,
                      'section-wrapper-expanded': this._downloadsExpanded,
                      'section-wrapper-closed': !this._downloadsExpanded,
                    })}
                  >
                    <div
                      class="section-header"
                      @click="${() => this.toggleSectionOpen('downloads')}"
                    >
                      <h3>DOWNLOADS</h3>
                      <img
                        class="mobile-only"
                        src=${this.sectionHeaderIcon('downloads')}
                      />
                    </div>
                    <div class="section-details" id="downloads">
                      ${this.downloadsHTML}
                    </div>
                  </span>
                `
              : html``
          }
          </section>
        </div>
      </div>
    `;
  }

  get headerText() {
    return this.content.heading || '';
  }

  get accountInformationText() {
    return this.content.account_information || '';
  }

  get accountInformationHTML() {
    return html`
      <p>
        ${unsafeHTML(this.withLineBreaks(this.accountInformationText))}
      </p>
    `;
  }

  get projectManagerHTML() {
    return html`
      <p class="manager-name">
        ${unsafeHTML(this.withLineBreaks(this.content.manager_name))}
      </p>
      <p>
        ${unsafeHTML(this.withLineBreaks(this.content.manager_phone))}
      </p>
      <p>
        ${unsafeHTML(this.withLineBreaks(this.content.manager_email))}
      </p>
    `;
  }

  get downloadsHTML() {
    return this.content.downloads.map(download => {
      return html`
        <cta-text
          cta-data=${JSON.stringify(download)}
          hide-right-arrow-svg="true"
          target-blank="true"
          left-download-svg="true"
          .ctaAnalyticsData=${analyticsCtaDataObject(
            download,
            `Direct ${this.headerText}`
          )}
        ></cta-text>
      `;
    });
  }

  sectionHeaderIcon(section) {
    const minimizeUrl = '/static/icons/SVG/minimize-dash.svg';
    const expandUrl = '/static/icons/SVG/expand-plus.svg';
    switch (section) {
      case 'account-information':
        return this._accountInfoExpanded ? minimizeUrl : expandUrl;
      case 'project-manager':
        return this._projectManagerExpanded ? minimizeUrl : expandUrl;
      case 'downloads':
        return this._downloadsExpanded ? minimizeUrl : expandUrl;
    }
  }

  toggleSectionOpen(section) {
    if (window.isMobile) {
      switch (section) {
        case 'account-information':
          return (this._accountInfoExpanded = !this._accountInfoExpanded);
        case 'project-manager':
          return (this._projectManagerExpanded = !this._projectManagerExpanded);
        case 'downloads':
          return (this._downloadsExpanded = !this._downloadsExpanded);
      }
    }
  }

  get logoUrl() {
    return this.imagebossUrl(this.content.logo_image_url, null, '48');
  }

  get featureImgUrl() {
    return this.content.feature_image_url
      ? this.imagebossUrl(this.content.feature_image_url, null, '500')
      : null;
  }
}
DirectGroup.defineElement();
